// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__web7l","label":"Completed_label__1ISse"};